import { createFileRoute } from '@tanstack/react-router';
import { AdminGuard } from '@/components/admin-guard';
import { AdminSubNav } from '@/components/shell/AdminSubNav';
import { ReleaseNoteEditor } from '@/features/release-notes/admin/ReleaseNoteEditor';

function EditionRoute() {
  const { key } = Route.useParams();
  return <ReleaseNoteEditor editionKey={key} />;
}

// The Slack messages about an edition link here.
export const Route = createFileRoute('/admin/release-notes/$key')({
  component: () => (
    <AdminGuard>
      <AdminSubNav />
      <div className="container mx-auto max-w-5xl p-6">
        <EditionRoute />
      </div>
    </AdminGuard>
  )
});
